import React, { useContext } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  styled,
  Typography
} from "@mui/material";
import { Icons } from "../../config/MuiIcons.config";
import AppButton from "../CommonReusableComponent/AppButton/AppButton";
import { AppTheme } from "../../theme/App.theme";
import { useSnackbar } from "../../contexts/Snackbar.context";
import { useBackdrop } from "../../contexts/BackDrop.context";
import { ERROR_MESSAGE, SNACKBAR_VARIANT } from "../../config/Messages.config";
import { useNavigate } from "react-router-dom";
import { AppGlobalContext } from "../../contexts/AppContext.context";
import { firebaseLogOut } from "../../services/authServices/auth.services";

const StyledDialog = styled(Dialog)(({ theme }) => ({
  zIndex: theme.zIndex.modal + 50, // Customize z-index here
}));

const UnAuthorizedUserPopup = ({ ModalState, ToggleFunction }) => {
  const { showSnackbar } = useSnackbar();
  const { hideBackdrop } = useBackdrop();
  const navigate = useNavigate();
  const { SetAppState } = useContext(AppGlobalContext);

  const handleUserLogout = () => {
    firebaseLogOut();
    hideBackdrop();
    SetAppState({
      isAuthUser: false,
      loggedInUserRole: false,
      responsibilities: null,
      authUserDetails: {},
    });
    localStorage.clear();
    navigate("/", {
      replace: true,
    });
    window.history.pushState(null, "", "/");
    ToggleFunction();
  };

  return (
    <StyledDialog
      open={ModalState}
      // onClose={() => ToggleFunction("Delete User")}
      aria-labelledby="form-dialog-title"
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle style={{ textAlign: "center" }}>
        <Icons.Error style={{ fontSize: 40, color: AppTheme.PRIMARY_COLOR }} />
      </DialogTitle>
      <DialogContent style={{ textAlign: "center" }}>
        <Typography style={{ fontSize: "24px" }} className="inter-regular-400">
          Your session has expired.
        </Typography>
        <Typography
          style={{ fontSize: "16px" }}
          className="inter-regular-400 my-2"
        >
          Your session has timed out, please log out and login again to continue.
        </Typography>
      </DialogContent>
      <DialogActions className="justify-content-center mb-3 mx-5">
        <AppButton
          Color={"error"}
          OnPress={() => {
            if (navigator.onLine) {
              handleUserLogout();
            } else {
              showSnackbar(
                ERROR_MESSAGE.INTERNET_ERROR,
                SNACKBAR_VARIANT.ERROR
              );
            }
          }}
        >
          Log Out
        </AppButton>
      </DialogActions>
    </StyledDialog>
  );
};

export default UnAuthorizedUserPopup;
